import Cookies from 'js-cookie';
import { normalizeCategoryPath } from '@/lib/category-url';
import { isPersistableShoppingPillar, type PersistableShoppingPillar } from '@/lib/navigation-pillars';
import {
    PRIMARY_SHOPPING_CATEGORY_COOKIE_NAME,
    PRIMARY_SHOPPING_PILLAR_COOKIE_NAME,
} from '@/lib/primary-shopping-category';

const COOKIE_MAX_AGE_DAYS = 30;

type PersistPrimaryShoppingCategoryOptions = {
    domain?: string;
    path: string;
    siteId: string;
};

type PersistPrimaryShoppingPillarOptions = {
    pillar: PersistableShoppingPillar;
    domain?: string;
    siteId: string;
};

/** Reads the site-scoped pillar cookie written by {@link persistPrimaryShoppingPillar}. */
export function readPrimaryShoppingPillarClient(siteId: string): PersistableShoppingPillar | null {
    const raw = Cookies.get(`${PRIMARY_SHOPPING_PILLAR_COOKIE_NAME}_${siteId}`)?.trim();
    return isPersistableShoppingPillar(raw) ? raw : null;
}

export function persistPrimaryShoppingPillar({ pillar, domain, siteId }: PersistPrimaryShoppingPillarOptions): void {
    Cookies.set(`${PRIMARY_SHOPPING_PILLAR_COOKIE_NAME}_${siteId}`, pillar, {
        domain,
        expires: COOKIE_MAX_AGE_DAYS,
        path: '/',
        sameSite: 'lax',
        secure: window.location.protocol === 'https:',
    });
}

export function persistPrimaryShoppingCategory({ domain, path, siteId }: PersistPrimaryShoppingCategoryOptions): void {
    const normalizedPath = normalizeCategoryPath(path);
    if (!normalizedPath) {
        return;
    }

    Cookies.set(`${PRIMARY_SHOPPING_CATEGORY_COOKIE_NAME}_${siteId}`, normalizedPath, {
        domain,
        expires: COOKIE_MAX_AGE_DAYS,
        path: '/',
        sameSite: 'lax',
        secure: window.location.protocol === 'https:',
    });
}
